import React, { Component } from 'react';
import { connect } from 'react-redux';

import { filterCompaniesByTypeDispatch, filterCompaniesByTextDispatch, setPageNumberDispatch, limitPageCountDispatch } from '../actions';

class SearchMembers extends Component {
	handleFormSubmit( event ) {
		event.preventDefault();
	}

	handleKeywordSearch( event ) {
		this.props.setPageNumberDispatch( 1 );
		this.props.filterCompaniesByTextDispatch( event.target.value );
	}

	triggerClearFilters( event ) {
		event.preventDefault();
		this.props.filterCompaniesByTextDispatch( '' );
		this.props.setPageNumberDispatch( 1 );
		this.props.filterCompaniesByTypeDispatch( 'all' );
	}

	handleDisplayChange( event ) {
		this.props.limitPageCountDispatch( event.target.getAttribute( 'data-count' ) );
		this.props.setPageNumberDispatch( 1 );
	}

	renderLimitCountOptions() {
		const options = [ 10, 30, 100, 'All' ];
		return options.map( option => {
			return (<li key={ option }>
					<a className="list-group-item list-group-item-action" name={ 'display-' + option } data-count={ option } onClick={ this.handleDisplayChange.bind( this ) }>Display { option }</a>
				</li>
			);
		} );
	}

	render() {
		return (
			<div id="member-sorting-bar" className="container">
				<form className="inner-page-search form-inline remove-border" role="search" aria-label="Company Keyword Filter Form" onSubmit={ this.handleFormSubmit.bind( this ) }>
					<div className="row">
						<div className="col-md-1 hidden-xs hidden-sm">
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_4106_1315)">
									<path d="M13.3243 10.5833V8.33335C13.3243 8.11233 13.4121 7.90037 13.5684 7.74409C13.7247 7.58781 13.9366 7.50001 14.1576 7.50001H14.991C15.212 7.50001 15.424 7.41222 15.5802 7.25594C15.7365 7.09966 15.8243 6.88769 15.8243 6.66668V5.83335C15.8243 5.61233 15.9121 5.40037 16.0684 5.24409C16.2247 5.08781 16.4366 5.00001 16.6576 5.00001H18.8951C19.0577 4.99922 19.2166 4.95166 19.3528 4.86299C19.4891 4.77433 19.5969 4.64832 19.6635 4.50001C19.9449 3.88016 20.0532 3.19564 19.9768 2.51918C19.8816 1.81487 19.5318 1.16978 18.9936 0.705673C18.4553 0.241567 17.7658 -0.00944679 17.0551 1.38585e-05C16.0524 7.72735e-05 15.0908 0.398456 14.3818 1.10751L7.79181 7.69585C6.72956 7.41989 5.61275 7.4337 4.55764 7.73585C3.10602 8.14633 1.85185 9.068 1.02656 10.3308C0.20127 11.5935 -0.139448 13.1122 0.0672798 14.6065C0.274008 16.1008 1.01423 17.4699 2.15136 18.4612C3.28848 19.4525 4.74577 19.999 6.25431 20C6.47253 19.9998 6.69059 19.9884 6.90764 19.9658C8.14944 19.8306 9.32262 19.3279 10.2769 18.5219C11.2312 17.7159 11.9232 16.6433 12.2643 15.4417C12.5674 14.387 12.5809 13.2701 12.3035 12.2083L12.8451 11.6667C13.1332 11.3771 13.3039 10.9912 13.3243 10.5833ZM4.58348 16.6667C4.33625 16.6667 4.09458 16.5934 3.88901 16.456C3.68345 16.3187 3.52324 16.1234 3.42863 15.895C3.33402 15.6666 3.30926 15.4153 3.3575 15.1728C3.40573 14.9303 3.52478 14.7076 3.69959 14.5328C3.87441 14.358 4.09714 14.2389 4.33961 14.1907C4.58209 14.1425 4.83342 14.1672 5.06183 14.2618C5.29024 14.3564 5.48546 14.5167 5.62281 14.7222C5.76017 14.9278 5.83348 15.1695 5.83348 15.4167C5.83348 15.7482 5.70178 16.0661 5.46736 16.3006C5.23294 16.535 4.915 16.6667 4.58348 16.6667Z" fill="#00549E"/>
								</g>
								<defs>
									<clipPath id="clip0_4106_1315">
										<rect width="20" height="20" fill="white"/>
									</clipPath>
								</defs>
							</svg>
						</div>
						<div className="form-group-keyword form-group col-sm-8 col-md-7">
							<label className="search-label sr-only" htmlFor="members-list-inner-page-search">Keyword Filter</label>
							<input type="search"
							       value={ this.props.searchTerm }
							       onChange={ this.handleKeywordSearch.bind( this ) }
							       className="form-control"
							       id="members-list-inner-page-search"
							       placeholder="Search ISDA Members" />
						</div>
					</div>
					<div className="dropdown pull-right">
						<a className="dropdown-toggle text-primary" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
							Display { this.props.pageCount }
							<span className="caret"></span>
						</a>
						<ul className="dropdown-menu list-group" aria-labelledby="">
							{ this.renderLimitCountOptions() }
						</ul>
					</div>
				</form>
			</div>
		);
	}
}

function mapStateToProps( { searchTerm, pageCount } ) {
	return { searchTerm, pageCount };
}

export default connect( mapStateToProps, {
	filterCompaniesByTextDispatch, setPageNumberDispatch, filterCompaniesByTypeDispatch, limitPageCountDispatch
} )( SearchMembers );